import { useRef } from "react";

/**
 * useStableLatestObject
 * Keeps a stable object identity while always reflecting the latest shallow field values.
 *
 * Notes:
 * - Shallow merge only (nested objects keep their own identity rules)
 * - Keys should stay stable; adding/removing keys frequently defeats the purpose
 */
export function useStableLatestObject<T extends Record<PropertyKey, unknown>>(value: T): T {
    const ref = useRef(value);
    // Always shallow-merge latest values into stable container.
    Object.assign(ref.current, value);
    return ref.current;
}

/** Convenience alias with more intention-revealing name */
export const useStableObject = useStableLatestObject;
